module.exports = __webpack_public_path__ + "img/plate02_03.a9981786.png";